export const languages = {
  'am': '암하라어',
  'ar': '아랍어',
  'eu': '바스크어',
  'bn': '벵골어',
  'en-GB': '영어(영국)',
  'pt-BR': '포르투갈어(브라질)',
  'bg': '불가리아어',
  'ca': '카탈로니아어',
  'chr': '체로키어',
  '시': '크로아티아어',
  'cs': '체코어',
  'da': '덴마크어',
  'nl': '네덜란드어',
  'en': '영어(미국)',
  'et': '에스토니아어',
  'fil': '필리핀어',
  'fi': '핀란드어',
  'fr': '프랑스어',
  'de': '독일어',
  'el': '그리스어',
  'gu': '구자라트어',
  'iw': '히브리어',
  'hi': '힌디어',
  'hu': '헝가리어',
  'is': '아이슬란드어',
  'id': '인도네시아어',
  'it': '이탈리아어',
  'ja': '일본어',
  'kn': '칸나다어',
  'ko': '한국어',
  'lv': '라트비아어',
  'lt': '리투아니아어',
  'ms': '말레이어',
  'ml': '말라얄람어',
  'mr': '마라타어',
  'no': '노르웨이어',
  'pl': '폴란드어',
  'pt-PT': '포르투갈어(포르투갈)',
  'ro': '루마니아어',
  'ru': '러시아어',
  'sr': '세르비아어',
  'zh-CN': '중국어(중화인민공화국)',
  'sk': '슬로바키아어',
  'sl': '슬로베니아어',
  'es': '스페인어',
  'sw': '스와힐리어',
  'sv': '스웨덴어',
  'ta': '타밀어',
  'te': '텔루구어',
  'th': '태국어',
  'zh-TW': '중국어(타이완)',
  'tr': '튀르키예어',
  'ur': '우르두어',
  'uk': '우크라이나어',
  'vi': '베트남어',
  'cy': '웨일즈어',
};